import React from 'react';
import { useNavigate } from 'react-router-dom';

const TermsOfService = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-white font-sans text-gray-900">
      <nav className="border-b border-gray-100 p-4 sticky top-0 bg-white/90 backdrop-blur z-10">
        <div className="max-w-4xl mx-auto flex justify-between items-center">
          <span className="font-bold text-xl flex items-center gap-2">
            <span className="text-2xl">📜</span> Terms of Service
          </span>
          <button onClick={() => navigate('/')} className="text-sm font-bold text-[#ee5b2b] hover:underline">Done</button>
        </div>
      </nav>

      <div className="max-w-4xl mx-auto px-6 py-12 space-y-8">
        <section>
          <h2 className="text-2xl font-bold mb-4">1. Acceptance of Terms</h2>
          <p className="text-gray-600 leading-relaxed">
            By creating an account or using TableAR, you agree to these Terms. If you do not agree, you may not use our services.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-bold mb-4">2. Restaurant Responsibilities</h2>
          <p className="text-gray-600 leading-relaxed">
            You are responsible for the accuracy of the menu items, prices, and allergen information you upload. TableAR is a platform and is not liable for errors in your menu content.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-bold mb-4">3. Subscription & Payments</h2>
          <p className="text-gray-600 leading-relaxed">
            TableAR offers both free and paid plans. Paid subscriptions are billed monthly. You may cancel at any time, but no refunds are provided for partial months.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-bold mb-4">4. Intellectual Property</h2>
          <p className="text-gray-600 leading-relaxed">
            You retain ownership of the photos and 3D models you upload. You grant TableAR a license to host and display this content to your customers.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-bold mb-4">5. Termination</h2>
          <p className="text-gray-600 leading-relaxed">
            We reserve the right to suspend accounts that violate these terms or upload illegal/inappropriate content.
          </p>
        </section>
      </div>
    </div>
  );
};

export default TermsOfService;